import React from 'react'
import {ToggleButtonGroup, ToggleButton} from '@mui/material'

export default function ChartGroupToggle({groupOn, setGroupOn}) {
  return (
    <ToggleButtonGroup
      value={groupOn}
      exclusive
      onChange={(_, val) => val && setGroupOn(val)}
      size='small'
    >
      <ToggleButton value='DOD' sx={{textTransform: 'none', fontSize: '0.75rem', px: 1.5}}>Daily</ToggleButton>
      <ToggleButton value='WOW' sx={{textTransform: 'none', fontSize: '0.75rem', px: 1.5}}>Weekly</ToggleButton>
      <ToggleButton value='MOM' sx={{textTransform: 'none', fontSize: '0.75rem', px: 1.5}}>Monthly</ToggleButton>
    </ToggleButtonGroup>
  )
}
